<template>
    <div v-if="chartData.datasets.length > 0">
        <Line :data="chartData" :options="chartOptions" :style="style" />
    </div>
    <div v-else>
        Carregando dados...
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js'
import { Line } from 'vue-chartjs'
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import { defineProps } from 'vue';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const props = defineProps({
  year: Number
});

const chartData = ref({
    labels: [],
    datasets: []
});

const chartOptions = ref({
    responsive: true,
    maintainAspectRatio: false,
     scales: {
        x: {
          display: true, // Hides the x-axis labels and grid lines
        },
        y: {
          display: true, // Hides the y-axis labels and grid lines
        },
      }

    
});

const style = ref({
    height: '300px', // Set your desired height here
    width: '100%',
    position: 'relative',
});



onMounted(async () => {
    try {
        const response = await api.get('/dashboard/historyClients',{params: {'year': props.year}}).then((response) => { return response; }).catch((error) => { handleRequestErrors(error.status) });
        const apiData = response.data;
        chartData.value = {
            labels: apiData.labels,
            datasets: [
                {
                    label: 'Ativos',
                    borderColor: 'rgba(1,97,38, 0.8)',
                    borderWidth: 2,
                    tension: 0.1,
                    backgroundColor: 'rgba(1,97,38, 0.3)',
                    data: apiData.active
                },
                {
                    label: 'Baixados',
                    borderColor: 'rgba(128,3,3, 0.8)', 
                    borderWidth: 2,
                    tension: 0.1,
                    backgroundColor: 'rgba(128,3,3, 0.3)',
                    data: apiData.downloaded
                }
            ]
        };
    } catch (error) {
        console.error('Error fetching data:', error);
    }
});
</script>